
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "cameraWall",
  components: {
  }
})
export default class HKcameraWallBack extends BaseVue {  
  //#region properties
      @Prop({ default:() => {} }) configData!: any; //配置参数
      @Prop({ default:() => [] }) initCameras!: any; //配置参数
      hkvideoEleIdBack=this.NewGuid();
      vedioHandle:any;//控件对象
      pubKey:string="";//公钥
      initCount=0;//初始化次数
      isBack=true
      IndexCode=""
      Time1=this.getCurrentDate("yyyy-MM-dd hh:mm:ss")
      Time2=this.getCurrentDate("yyyy-MM-dd hh:mm:ss")
      configDataDefault:any= {
        appkey: "29839557",
        secret: "56ZUMCONyxBFYmuqPbLm",  
        ip: "47.110.252.137",    
        port:'1443',   
        playMode: 1, // 预览
        snapDir: "C:\SnapDir",
        videoDir: "C:\SnapDir",
        layout:"1x1",//默认9画面
        enableHTTPS: 1,
        showToolbar: 1,
        showSmart:"1",
        language: "zh_CN",
        encryptedFields: "",//appkey,secret,ip
        reconnectTimes: 5,
        reconnectDuration: 5,
        Bak: "0,257,258,512,513,516,517",
        NDY: 1,
        IsReturn:0
      }; 
      configDataNew:any={};
      VideoCrl:any={
        width:0,
        height:0,
      }
  //#endregion
  //#region event
  @Watch("configData",{deep:true})
  configDataChange(){
    this.configDataNew = Object.assign(this.configDataDefault,this.configData)
  }
  @Watch("initCameras",{deep:true})
  initCamerasChange(){
    if(this.vedioHandle){
      this.appendMultipCameraInPanel()  
    }        
  }
  mounted() { 
    this.configDataNew = Object.assign(this.configDataDefault,this.configData)
    // this.createScript("/static/hk/jsencrypt.min.js","jsencrypt")
    // this.createScript("/static/hk/jsWebControl-1.0.0.min.js","jsWebControl")
    this.$nextTick(()=>{
        this.VideoCrl={
          width:$('#'+this.hkvideoEleIdBack).parent().width(),
          height:$('#'+this.hkvideoEleIdBack).parent().height()
        }
      this.initialHandle();       
    })    
  }
  disposeHandle () {//销毁插件
    this.vedioHandle.JS_DestroyWnd().then(()=>{
      console.log("销毁完成")
    })
  }
  HideWnd () {//隐藏窗口
    this.vedioHandle.JS_HideWnd()
  }
  ShowWnd () {//显示窗口
    this.vedioHandle.JS_ShowWnd()
  }
  destroyed(){
    this.HideWnd()
    this.disposeHandle()
  }
  //#endregion
  //#region method 
  initialHandle () {
    this.vedioHandle= new window['WebControl']({     // 创建 WebControl 实例  
        szPluginContainer: this.hkvideoEleIdBack,    // 指定 DIV 窗口标识             
        iServicePortStart: 15900,         // 指定起止端口号，建议使用该值             
        iServicePortEnd: 15909,
        szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11",
        cbConnectSuccess: ()=> { // 实例创建成功后启动服务                                                      
            this.vedioHandle.JS_StartService("window", {
                dllPath: "./VideoPluginConnect.dll"//  
            }).then(()=> {  // 启动插件服务成功 
                this.vedioHandle.JS_SetWindowControlCallback({
                    cbIntegrationCallBack: (msgobj)=> {
                        // console.log("mmm:"+JSON.stringify(msgobj));
                    }
                }); // 设置消息回调  
                this.vedioHandle.JS_CreateWnd(this.hkvideoEleIdBack, $('#'+this.hkvideoEleIdBack).parent().width(), $('#'+this.hkvideoEleIdBack).parent().height()).then(()=> { //JS_CreateWnd 创建视频播放窗口，宽高可设定     
                    this.getPubKey(this.initialsWall); 
                });
            },()=> { // 启动插件服务失败                
            });
        },
        cbConnectError: ()=> {
            this.vedioHandle = null;
            $("#"+this.hkvideoEleIdBack).html("插件未启动，正在尝试启动，请稍候...");
            window["WebControl"].JS_WakeUp("VideoWebPlugin://");
            this.initCount++;
            if (this.initCount < 3) {
                setTimeout(()=> { this.initialHandle(); }, 3000)
            }
            else {
                $("#"+this.hkvideoEleIdBack).html("插件启动失败，请检查插件是否安装！<a href='/static/hk/VideoWebPlugin.exe'>点击下载</a>");
                this.initCount = 0;
                this.unloadWall();
            }
        },
        cbConnectClose: (bNormalClose)=> {           // bNormalClose = false 时表示异常断开    // bNormalClose = true 时表示正常断开           
            console.log("cbConnectClose");
            this.vedioHandle = null;
        }
    });
  } 
  initialsWall() {//创建 
    if (this.configDataNew.encryptedFields == '') {
        this.configDataNew.appkey = this.setEncrypt(this.configDataNew.appkey);
        this.configDataNew.secret = this.setEncrypt(this.configDataNew.secret);
        this.configDataNew.ip = this.setEncrypt(this.configDataNew.ip);
        this.configDataNew.port = Number(this.configDataNew.port);
        this.configDataNew.showSmart = Number(this.configDataNew.showSmart);  
        this.configDataNew.playMode=1
        this.configDataNew.layout="1x1"
        this.configDataNew.encryptedFields = "appkey,secret,ip";
    } 

    this.vedioHandle.JS_RequestInterface({
        funcName: "init",
        argument: JSON.stringify(this.configDataNew)
    }).then((oData)=> {
        console.log(JSON.stringify(oData ? oData.responseMsg : ''));  
    });
  }
  unloadWall(){
    if (null != this.vedioHandle) {
        this.vedioHandle.JS_HideWnd();
        this.vedioHandle.JS_RequestInterface({ funcName: "stopAllPreview" });
    }
  }
  setEncrypt(value) {//密钥加密  
      var encrypt = new window["JSEncrypt"]();
      encrypt.setPublicKey(this.pubKey);
      return encrypt.encrypt(value);
  }
  getPubKey(callback){
      this.vedioHandle.JS_RequestInterface({
          funcName: "getRSAPubKey",
          argument: JSON.stringify({ keyLength: 1024 })
      }).then((oData)=> { 
          if (oData.responseMsg.data) {
              this.pubKey = oData.responseMsg.data; 
              callback && callback();
          }
      })
  }
  appendMultipCameraInPanel () {//cameras:[] 
      if (this.initCameras.length == 0) return;
      let slist:any = [];
      this.initCameras.forEach((item,i) => {
        slist.push({
          cameraIndexCode: item, 
          streamMode: 0,//主码流
          transMode: 1,//tcp
          gpuMode: 0,
          wndId: i+1,
          ezvizDirect: 0//直接连接萤石云
        });
      }) 
      this.vedioHandle.JS_RequestInterface({
        funcName: "startMultiPreviewByCameraIndexCode",
        argument: { "list": slist }
      }).then(function (oData) {
          console.log(JSON.stringify(oData ? oData.responseMsg : ''));
      });
      
  }
  addCameraInSelectWindow(tkey,winId) { 
      this.vedioHandle.JS_RequestInterface({
          funcName: "startPreview",
          argument: {
            cameraIndexCode: tkey, 
            streamMode: 0,//主码流
            transMode: 1,//tcp
            gpuMode: 0,
            wndId: winId,
            ezvizDirect: 0//直接连接萤石云
          }
      }).then(function (oData) {
          console.log(JSON.stringify(oData ? oData.responseMsg : ''));
      });
  } 
  CameraRefreshPosition(){  
     this.vedioHandle.JS_Resize(this.VideoCrl.width, this.VideoCrl.height);
  }

  /**
   * @description: 开始回放
   * @param {*}
   * @return {*}
   */  
  StarPlay(){
     console.log(this.Time1)
     console.log(this.Time2)
     this.vedioHandle.JS_RequestInterface({
            funcName: "startPlayback",
            argument: JSON.stringify({
                cameraIndexCode: this.IndexCode,                   //监控点编号
                startTimeStamp: Math.floor(new Date(this.Time1).getTime() / 1000).toString(),  //录像查询开始时间戳，单位：秒
                endTimeStamp: Math.floor(new Date(this.Time2).getTime() / 1000).toString(),      //录像结束开始时间戳，单位：秒
                recordLocation: 1,                     //录像存储类型：0-中心存储，1-设备存储
                transMode: 1,                               //传输协议：0-UDP，1-TCP
                gpuMode: 0,                                   //是否启用GPU硬解，0-不启用，1-启用
                wndId:-1                                         //可指定播放窗口
            })
      })
  }

  /**
   * @description: 停止回放
   * @param {*}
   * @return {*}
   */  
  StopPlay(){
        this.vedioHandle.JS_RequestInterface({
            funcName: "stopAllPlayback"
        })
  }

  playBack(IndexCode){
      this.IndexCode=IndexCode
  }

  ReturnPlay(){
    this.$emit("ReturnPlay")
  }
  
  //#endregion
}
